import store from '@/store/index.js';

export const customRequest = {
  data() {
    return {
      defaultHeader: {
        'Content-Type': 'application/json',
      },
      baseURL: '',
    };
  },
  methods: {
    postRequest: function (path, data, header) {
      if (header) {
        for (const [key, value] of Object.entries(header)) {
          this.defaultHeader[key] = header[value];
        }
      }
      if (!data) data = {};

      // 独自ヘッダ追加(PoCでは対象外、商用で使う予定)
      // this.defaultHeader['X-CCC-Request'] = 'cotohacallcenter';

      data._csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      if (!data.companyID && this.$route.query.companyID) {
        // 権限チェックする際にprocessCompanyIDが必要
        data.companyID = this.$route.query.companyID;
      }
      return fetch(`${this.baseURL}${path}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.defaultHeader,
      }).then(response => {
        store.dispatch('updateLatestRequestTime');
        if (response.status === 401 || response.status === 403) {
          // session expired (Salesforce)
          if (this.$route.path.match(/^\/sf-/)) {
            return (window.location.href = '/sf-login');
          }
          //session expired
          if (this.$route.path !== '/login') {
            return (window.location.href = '/login');
          }
        }
        if (response.status === 404) {
          throw 404;
        }
        if (!response.ok) {
          throw new Error(path + ' response was not ok.');
        } else {
          return response.json();
        }
      });
    },
  },
};
